export const attachmentPreviewTypes = ['gif', 'svg', 'jpeg', 'jpg', 'png', 'txt', 'pdf', 'mp4', 'mkv', 'mov', 'webp', 'avif'];
